"use strict";

$(function () {
    var $video = $('#video-modal video');
    var video_dom = $video.get(0);

    $('.btn-play').click(function () {
        if ($video.attr('src') != $(this).data('video')) {
            $video.attr('src', $(this).data('video'));
        }

        video_dom.play();
    });

    $('#video-modal').on('hide.bs.modal', function () {
        video_dom.pause();
    });

    $video.click(function () {
        if (video_dom.paused) {
            video_dom.play();
        } else {
            video_dom.pause();
        }
    });

    $video.dblclick(function () {
        video_dom.webkitEnterFullScreen();
    });
});
